/**
 * Parse inject boundary values into positive integer IDs.
 * Use once when reading URL/context — downstream code receives number | null.
 */
const parsePositiveIntId = (value) => {
  if (value == null || value === '') return null
  const trimmed = String(value).trim()
  if (!trimmed || trimmed === 'new' || trimmed === 'create') return null
  const num = Number(trimmed)
  if (!Number.isInteger(num) || num <= 0) return null
  return num
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { parsePositiveIntId }
}
